import { Box, TextField, Button, IconButton, Autocomplete } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { logDev } from "../../utils/logger.js"

const ItemRow = ({
  item,
  articles,
  isMobile,
  onChangeArticle,
  onChangeQuantity,
  onSave,
  onDelete,
  saved,
  t,
  onChangeDraftName,
  canEdit, 
}) => {
  // Mode édition local (si l’item n’est pas encore sauvegardé → édition directe)
  //const isEditing = item._isEditing || !item._id;
  logDev("🟣 ItemRow DEBUG", {
    itemId: item._id,
    saved,
    canEdit,
    draftName: item.draftName,
    articleId: item.articleId,
    quantity: item.quantity
  });


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: { xs: 1, sm: 1 },
        mt: { xs: 1, sm: 0.8 },
        width: "100%"
      }}
    >
      {/* 📝 ARTICLE */}
      <Autocomplete
        freeSolo
        disabled={saved || !canEdit}
        options={articles}
        getOptionLabel={(a) => a.name}
        value={articles.find(a => a._id === item.articleId?._id) || null}
        inputValue={
          item.draftName 
          || item.articleId?.name 
          || ""
        }
        onInputChange={(e, value) => onChangeDraftName(value)}
        onChange={(e, value) => onChangeArticle(value)}
        sx={{
          flexGrow: 1,
          minWidth: { xs: "100%", sm: "180px" },
          "& .MuiInputBase-root": {
            height: 36,                             // 🔥 réduit la hauteur
            fontSize: "0.85rem"                     // 🔥 texte plus petit
          },
          opacity: saved ? 0.6 : 1
          
        }}
        renderInput={(params) => (
          <TextField {...params} label={t("Item")} size="small" />
        )}
      />

      {/* 🔢 QUANTITÉ */}
      <TextField
        disabled={saved || !canEdit} 
        type="number"
        label={t("Qte")}
        value={item.quantity}
        onFocus={() => item.quantity === 0 && onChangeQuantity("")}
        onBlur={() => (item.quantity === "" || item.quantity === null) && onChangeQuantity(0)}
        onChange={(e) => {
          const val = e.target.value;
          onChangeQuantity(val === "" ? "" : Number(val));
        }}
        size="small"  
        sx={{
          width: { xs: "100%", sm: 120 },
          "& .MuiInputBase-root": {
            height: 36,                               // 🔥 réduit la hauteur
            fontSize: "0.85rem"
          },
          opacity: saved || !canEdit ? 0.6 : 1
        }}
      />

      {/* 💾 BOUTON SAUVEGARDER */}
      {canEdit && !saved && (
        <IconButton
          onClick={onSave}
          sx={{ color: "green", p: 0.5  }}
        >
          <SaveIcon fontSize="small" />
        </IconButton>
      )}

      {/* ✔️ COCHE VERTE APRÈS SAUVEGARDE */}
      {saved && (
        <IconButton disabled sx={{ color: "green", p: 0.5 }}>
          <CheckCircleIcon fontSize="small" />
        </IconButton>
      )}

      {/* 🗑 BOUTON SUPPRIMER */}
      <IconButton color="error" onClick={onDelete} disabled={!canEdit} sx={{ p: 0.5 }}>
        <DeleteIcon fontSize="small"/>
      </IconButton>

    </Box>
  );
};

export default ItemRow;
